export const GET_BIKE_MODEL_VARIANTS_REQUEST = 'GET_BIKE_MODEL_VARIANTS_REQUEST';
export const GET_BIKE_MODEL_VARIANTS_REQUEST_SUCCESS = 'GET_BIKE_MODEL_VARIANTS_REQUEST_SUCCESS';
export const GET_BIKE_MODEL_VARIANTS_REQUEST_FAILURE = 'GET_BIKE_MODEL_VARIANTS_REQUEST_FAILURE';

export const CHANGE_BIKE_MODEL_VARIANTS_REQUEST = 'CHANGE_BIKE_MODEL_VARIANTS_REQUEST';
export const CHANGE_BIKE_MODEL_VARIANTS_REQUEST_SUCCESS = 'CHANGE_BIKE_MODEL_VARIANTS_REQUEST_SUCCESS';
export const CHANGE_BIKE_MODEL_VARIANTS_REQUEST_FAILURE = 'CHANGE_BIKE_MODEL_VARIANTS_REQUEST_FAILURE';



// WEBPACK FOOTER //
// ./src/modules/PlatformManagement/Bike_model_update/redux/constants/bike_model_variants.constants.js